const ExperienceData = [
    {
        title: 'Experience',
        list: [
            {
                title: 'UX/UI Design',
                items: [],
            },
            {
                title: 'Brand Design',
                items: [],
            },
            {
                title: 'Front-End Web Development',
                items: [],
            },
            {
                title: 'Back-End Web Development',
                items: [],
            },
            {
                title: 'Mobile Website Design & Development',
                items: [],
            },
            {
                title: 'Content Management System Design & Development',
                items: [],
            },                 
            {
                title: 'Responsive Web Design',
                items: [],
            },
            {
                title: 'Atomic Web Development',
                items: [],
            },
            {
                title: 'Agile Development Process',
                items: [],
            },
            {
                title: 'Search Engine Optimization',
                items: [],
            },
            {
                title: 'Quality Assurance',
                items: [],
            },
            {
                title: 'Test-Driven Development',
                items: [],
            },
            {
                title: 'W3C Compliance',
                items: [],
            },
            {
                title: 'Web Accessibility & ADA Compliance',
                items: [],
            },
            {
                title: 'Multimedia Production',
                items: [],
            },  
        ],
    },
    {
        title: 'Web Technologies',
        list: [
            {
                title: 'Languages',
                items: ['HTML 5','CSS3','PHP','Javascript ES6','XML','JSon','Actionscript'],
            },
            {
                title: 'Content Management Systems',
                items: ['Drupal 10','Wordpress','Saxotech','Point & Clique'],
            },
            {
                title: 'CSS Frameworks',
                items: ['SCSS/SASS','Tailwind','Material UI','Bootstrap'],
            },
            {
                title: 'Javascript Frameworks',
                items: ['JQuery','JQuery-UI','React',"Angular","TypeScript","Node.js","Next.js"],
            },
            {
                title: 'PHP Frameworks',
                items: ['CodeIgniter',"Symphony","Twig"],
            },
            {
                title: 'Test-Driven Development',
                items: ['Jest','Cypress','Storybook','Nightwatch']
            },   
            {
                title: 'Version Control Systems',
                items: ['GIT','Subversion'],
            }                 
        ],
    },
    {
        title: 'Applications',
        list: [
            {
                title: 'Adobe Creative Suite',
                items: ['Photoshop','Illustrator','XD','InDesign','Premiere','After Effects','Animate','Soundbooth','Media Encoder','Acrobat'
                ],
            },
            {
                title: "Figma",
                items: []
            },
            {
                title: 'Microsoft Office Suite',
                items: ['Word','Excel','Powerpoint'],
            },
            {
                title: 'Cloud Platforms',
                items: ['AWS', 'Acquia']
            },
            {
                title: 'Code Editors',
                items: ['Sublime','Visual Studio Code','VIM']
            },
            {
                title: 'Database Clients',
                items: ['MySQL Workbench', 'Robo 3T']
            }, 
            {
                title: 'Google Analytics',
                items: [],
            },
            {
                title: 'Google Search Console',
                items: [],
            },
            {
                title: "JAWS",
                items: []
            }
        ],
    },
]

export default ExperienceData;